var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.logos.desktop || _setup.logos.mobile)?_c('img',{staticClass:"h-full w-full object-contain",attrs:{"src":_setup.logos.desktop || _setup.logos.mobile}}):_c('UiIcon',{attrs:{"icon":"logoMain","container-size":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }